import { render, staticRenderFns } from "./myEmailPage.vue?vue&type=template&id=a0fabb0e&scoped=true&"
import script from "./myEmailPage.vue?vue&type=script&lang=ts&"
export * from "./myEmailPage.vue?vue&type=script&lang=ts&"
import style0 from "./myEmailPage.vue?vue&type=style&index=0&id=a0fabb0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fabb0e",
  null
  
)

export default component.exports